var _defs, _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropdocsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "86 65 510 338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef5324;}.cls-2{fill:#126c90;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Final Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.57,0h-9.45V112.06a30.55,30.55,0,0,1-30.55,30.55h-1.89a30.55,30.55,0,0,0-30.55,30.55V253h72.44a73.83,73.83,0,0,0,73.83-73.83V73.84A73.83,73.83,0,0,0,188.57,0",
    transform: "translate(208.8 115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.83,253h9.45V140.94a30.55,30.55,0,0,1,30.55-30.55h1.89a30.55,30.55,0,0,0,30.55-30.55V0H73.83A73.83,73.83,0,0,0,0,73.83V179.16A73.83,73.83,0,0,0,73.83,253",
    transform: "translate(208.8 115)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 680,
    height: 483
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 680,
    height: 483
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropdocsIcon);
export default __webpack_public_path__ + "static/media/propdocs-icon.fa9c2c41ac4d8bbbbb6fa26ce7ae9d4a.svg";
export { ForwardRef as ReactComponent };